// داده‌ی ساختگیِ اولیه‌ی حالت دمو. src/core/demo/store.ts این‌ها رو کپی می‌کنه و
// در طول جلسه تغییرشون می‌ده؛ این فایل فقط نقطه‌ی شروعه.
import type {
  AppNotification, AvailabilityCell, Business, EventItem, Friend, Group, ImportedContact,
  Message, NotifPrefs, Plan, Profile, Recipient, Signal, Tag,
} from '../domain/types';

export const DEMO_PROFILE: Profile = {
  id: 'demo-me',
  username: 'demo_parviz',
  displayName: 'پرویز (دمو)',
  avatarEmoji: '🦊',
  city: 'اتاوا',
  country: 'کانادا',
  // همون شناسه‌ی اتاوا توی cityRepo.DEMO_APP_CITIES — بدونش صفحه‌ی کشفِ دمو
  // شهر نداره و فهرستش خالی می‌مونه.
  cityId: 1,
  statusText: 'فقط دارم دمو رو نشون میدم 👀',
  avatarPath: null,
  avatarUrl: null,
  isAdmin: true,
};

const person = (id: string, username: string, displayName: string, emoji: string, city = 'اتاوا'): Profile => ({
  id, username, displayName, avatarEmoji: emoji, city, country: 'کانادا',
  statusText: null, avatarPath: null, avatarUrl: null,
});

export const SARA = person('demo-sara', 'sara', 'سارا', '🌸');
export const ARASH = person('demo-arash', 'arash', 'آرش', '🎸');
export const NEGAR = person('demo-negar', 'negar', 'نگار', '🎨');
export const KIAN = person('demo-kian', 'kian', 'کیان', '🏀');
export const MARYAM = person('demo-maryam', 'maryam', 'مریم', '🍰');

export function demoFriends(): Friend[] {
  return [
    { friendshipId: 1, profile: SARA, status: 'accepted', plansTogether: 3 },
    { friendshipId: 2, profile: ARASH, status: 'accepted', plansTogether: 1 },
    { friendshipId: 3, profile: NEGAR, status: 'pending_in' },
    { friendshipId: 4, profile: KIAN, status: 'pending_out' },
    { friendshipId: 5, profile: MARYAM, status: 'accepted', plansTogether: 2 },
  ];
}

const inTwoDays = () => new Date(Date.now() + 2 * 86_400_000).toISOString();
const inFiveDays = () => new Date(Date.now() + 5 * 86_400_000).toISOString();
const tomorrow = () => new Date(Date.now() + 1 * 86_400_000).toISOString();
const yesterday = () => new Date(Date.now() - 1 * 86_400_000).toISOString();
const hoursAgo = (h: number) => new Date(Date.now() - h * 3_600_000).toISOString();

export function demoSignals(): Signal[] {
  return [
    {
      id: 's1', creatorId: SARA.id, creator: SARA, kind: 'definite',
      title: 'هایک گتینو 🥾', note: 'صبح زود بریم که پارکینگ گیر بیاد',
      categoryId: 1, timeMode: 'exact', startsAt: inTwoDays(), placeName: 'Gatineau Park',
      chainLimit: 0, status: 'active', version: 1, shareToken: 'demo-s1', createdAt: hoursAgo(20),
      counts: { in: 1, out: 0, maybe: 1, pending: 1, conditional: 0 },
      myResponse: 'pending',
    },
    {
      id: 's2', creatorId: ARASH.id, creator: ARASH, kind: 'hosting',
      title: 'شام خونه‌ی من 🍲', note: 'خورش قورمه‌سبزی رو کاملاً جدی می‌گیرم',
      categoryId: 3, timeMode: 'approx', approxLabel: 'این آخر هفته',
      chainLimit: 1, status: 'active', version: 1, shareToken: 'demo-s2', createdAt: hoursAgo(30),
      counts: { in: 2, out: 0, maybe: 0, pending: 0, conditional: 0 },
      myResponse: 'in',
    },
    {
      id: 's3', creatorId: MARYAM.id, creator: MARYAM, kind: 'if_company',
      title: 'سینما 🎬 اگه کسی پایه باشه', categoryId: 4, timeMode: 'coordinate',
      chainLimit: 2, status: 'active', version: 1, shareToken: 'demo-s3', createdAt: hoursAgo(5),
      counts: { in: 0, out: 0, maybe: 0, pending: 2, conditional: 0 },
      myResponse: 'pending',
    },
    {
      id: 's4', creatorId: SARA.id, creator: SARA, kind: 'definite',
      title: 'قهوه صبحونه ☕', categoryId: 2, timeMode: 'exact', startsAt: tomorrow(),
      placeName: 'Bridgehead - Wellington', chainLimit: 0, status: 'confirmed',
      version: 1, shareToken: 'demo-s4', createdAt: hoursAgo(48),
      counts: { in: 1, out: 0, maybe: 0, pending: 0, conditional: 0 },
      myResponse: 'in',
    },
    {
      id: 's5', creatorId: DEMO_PROFILE.id, creator: DEMO_PROFILE, kind: 'open_idea',
      title: 'کی پایه‌ی پیاده‌روی دوره؟ 🚶', categoryId: 1, timeMode: 'from_availability',
      chainLimit: 0, status: 'active', version: 1, shareToken: 'demo-s5', createdAt: hoursAgo(10),
      counts: { in: 1, out: 0, maybe: 1, pending: 1, conditional: 0 },
    },
    {
      id: 's6', creatorId: DEMO_PROFILE.id, creator: DEMO_PROFILE, kind: 'poll',
      title: 'کدوم رستوران بریم؟ 🍜', categoryId: 3, timeMode: 'approx',
      approxLabel: 'جمعه شب', chainLimit: 0, status: 'active',
      version: 1, shareToken: 'demo-s6', createdAt: hoursAgo(3),
      counts: { in: 2, out: 1, maybe: 0, pending: 0, conditional: 0 },
    },
    {
      id: 's7', creatorId: DEMO_PROFILE.id, creator: DEMO_PROFILE, kind: 'definite',
      title: 'تولد نگار 🎂', categoryId: 3, timeMode: 'exact', startsAt: yesterday(),
      placeName: 'خونه‌ی نگار', chainLimit: 0, status: 'completed',
      version: 1, shareToken: 'demo-s7', createdAt: hoursAgo(96),
      counts: { in: 3, out: 0, maybe: 0, pending: 0, conditional: 0 },
    },
  ];
}

export function demoRecipients(): Record<string, Recipient[]> {
  return {
    s1: [
      { id: 1, signalId: 's1', recipientId: DEMO_PROFILE.id, profile: DEMO_PROFILE, via: 'direct', response: 'pending' },
      { id: 2, signalId: 's1', recipientId: ARASH.id, profile: ARASH, via: 'direct', response: 'in' },
      { id: 3, signalId: 's1', recipientId: MARYAM.id, profile: MARYAM, via: 'direct', response: 'maybe' },
    ],
    s5: [
      { id: 4, signalId: 's5', recipientId: SARA.id, profile: SARA, via: 'direct', response: 'in' },
      { id: 5, signalId: 's5', recipientId: ARASH.id, profile: ARASH, via: 'direct', response: 'maybe' },
      { id: 6, signalId: 's5', recipientId: MARYAM.id, profile: MARYAM, via: 'direct', response: 'pending' },
    ],
    s6: [
      { id: 7, signalId: 's6', recipientId: SARA.id, profile: SARA, via: 'direct', response: 'in' },
      { id: 8, signalId: 's6', recipientId: ARASH.id, profile: ARASH, via: 'direct', response: 'in' },
      { id: 9, signalId: 's6', recipientId: MARYAM.id, profile: MARYAM, via: 'direct', response: 'out' },
    ],
  };
}

export function demoPlans(): Record<string, Plan> {
  return {
    s4: {
      signalId: 's4', finalStartsAt: tomorrow(), finalPlace: 'Bridgehead - Wellington',
      reminderMin: 60, outcome: 'pending', shareScope: 'friends',
    },
  };
}

export function demoMessages(): Record<string, Message[]> {
  return {
    s4: [
      { id: 1, signalId: 's4', kind: 'system', body: 'سارا برنامه رو قطعی کرد.', createdAt: hoursAgo(40) },
      { id: 2, signalId: 's4', senderId: SARA.id, senderName: SARA.displayName, kind: 'text', body: 'کافه رو من رزرو می‌کنم، نگران نباش 😊', createdAt: hoursAgo(39) },
      { id: 3, signalId: 's4', senderId: DEMO_PROFILE.id, senderName: DEMO_PROFILE.displayName, kind: 'text', body: 'عالیه، می‌بینمت!', createdAt: hoursAgo(38) },
    ],
  };
}

export function demoNotifications(): AppNotification[] {
  return [
    {
      id: 1, kind: 'signal_received', title: 'سارا', body: 'هایک گتینو 🥾',
      data: { signal_id: 's1' }, readAt: null, createdAt: hoursAgo(20),
    },
    {
      id: 2, kind: 'friend_request', title: 'نگار', body: null,
      data: {}, readAt: null, createdAt: hoursAgo(15),
    },
    {
      id: 3, kind: 'signal_received', title: 'مریم', body: 'سینما 🎬 اگه کسی پایه باشه',
      data: { signal_id: 's3' }, readAt: null, createdAt: hoursAgo(5),
    },
    {
      id: 4, kind: 'friend_accepted', title: 'مریم', body: null,
      data: {}, readAt: hoursAgo(100), createdAt: hoursAgo(120),
    },
    {
      id: 5, kind: 'contact_joined', title: 'یکی از مخاطبینت به گوآوت پیوست', body: null,
      data: {}, readAt: hoursAgo(50), createdAt: hoursAgo(60),
    },
  ];
}

export function demoContacts(): ImportedContact[] {
  const base = {
    hidden: false, source: 'device' as const, syncedAt: hoursAgo(200),
  };
  return [
    {
      ...base, id: 1, deviceId: 'dev-1', displayName: 'سارا', firstName: 'سارا', lastName: null,
      emails: ['sara@example.com'], phones: ['+16135550101'], relationships: [], socialProfiles: [],
      company: null, isFriend: true, matchedUserId: SARA.id, matched: SARA,
    },
    {
      ...base, id: 2, deviceId: 'dev-2', displayName: 'آرش', firstName: 'آرش', lastName: null,
      emails: [], phones: ['+16135550102'], relationships: [], socialProfiles: [],
      company: null, isFriend: true, matchedUserId: ARASH.id, matched: ARASH,
    },
    {
      ...base, id: 3, deviceId: 'dev-3', displayName: 'نگار', firstName: 'نگار', lastName: null,
      emails: ['negar@example.com'], phones: [], relationships: [], socialProfiles: [],
      company: null, isFriend: false, matchedUserId: NEGAR.id, matched: NEGAR,
    },
    {
      ...base, id: 4, deviceId: 'dev-4', displayName: 'محمد (دوست قدیمی)', firstName: 'محمد', lastName: null,
      emails: [], phones: ['+16135550104'], relationships: [], socialProfiles: [],
      company: null, isFriend: false, matchedUserId: null,
    },
    {
      ...base, id: 5, deviceId: 'dev-5', displayName: 'الناز (همکار)', firstName: 'الناز', lastName: null,
      emails: ['elnaz@example.com'], phones: [], relationships: [], socialProfiles: [],
      company: 'شرکت نمونه', isFriend: true, matchedUserId: null,
    },
    {
      ...base, id: 6, deviceId: 'dev-6', displayName: 'عمو رضا', firstName: 'رضا', lastName: null,
      emails: [], phones: ['+16135550106'], relationships: [{ label: 'عمو', name: null }], socialProfiles: [],
      company: null, isFriend: false, matchedUserId: null,
    },
    {
      ...base, id: 7, deviceId: 'dev-7', displayName: 'سمیرا (همسایه)', firstName: 'سمیرا', lastName: null,
      emails: [], phones: [], relationships: [], socialProfiles: [],
      company: null, isFriend: false, matchedUserId: null,
    },
    {
      ...base, id: 8, deviceId: 'dev-8', displayName: 'باشگاه پویا', firstName: null, lastName: null,
      emails: [], phones: ['+16135550108'], relationships: [], socialProfiles: [],
      company: null, isFriend: false, matchedUserId: null,
    },
  ];
}

export function demoGroups(): Group[] {
  return [
    { id: 1, name: 'دوستای هایک 🥾', emoji: '🥾', ownerId: DEMO_PROFILE.id, memberUserIds: [SARA.id, ARASH.id], memberContactIds: [5] },
  ];
}

export function demoTags(): Tag[] {
  return [
    { id: 1, slug: 'hike', emoji: '🥾', labelFa: 'پیاده‌روی', labelEn: 'Hike' },
    { id: 2, slug: 'coffee', emoji: '☕', labelFa: 'قهوه', labelEn: 'Coffee' },
    { id: 3, slug: 'food', emoji: '🍜', labelFa: 'غذا', labelEn: 'Food' },
    { id: 4, slug: 'movie', emoji: '🎬', labelFa: 'سینما', labelEn: 'Movie' },
    { id: 5, slug: 'game', emoji: '🎮', labelFa: 'بازی', labelEn: 'Game' },
  ];
}

export function demoEvents(): EventItem[] {
  return [
    {
      id: 'evt-1', title: 'کنسرت پارک مجیر 🎵', description: 'موسیقی زنده‌ی رایگان زیر آسمون',
      categoryId: 4, venueName: "Major's Hill Park", startsAt: inFiveDays(),
      isFree: true, priceNote: null, isPromoted: true,
    },
    {
      id: 'evt-2', title: 'بازار محلی بایوارد 🧺', description: 'میوه و صنایع‌دستی محلی',
      categoryId: 3, venueName: 'ByWard Market', startsAt: inTwoDays(),
      isFree: true, priceNote: null, isPromoted: false,
    },
    {
      id: 'evt-3', title: 'شب بازی رومیزی 🎲', description: 'برد گیم و دوستای تازه',
      categoryId: 5, venueName: 'Board Game Cafe', startsAt: inFiveDays(),
      isFree: false, priceNote: '۱۰ دلار ورودی', isPromoted: false,
    },
  ];
}

export function demoBusinesses(): Business[] {
  return [
    {
      id: 'biz-1', name: 'کافه‌ی گوشه‌ی خیابون ☕', description: 'قهوه‌ی اسپشالتی و فضای آروم',
      categoryId: 2, address: 'Bank St, Ottawa', url: 'https://example.com/demo-business-1',
      hasDiscount: true, discountNote: '۱۰٪ تخفیف برای دوستای گوآوت', isPromoted: false, status: 'published',
    },
    {
      id: 'biz-2', name: 'رستوران نودل شهر 🍜', description: 'نودل دستی و سوپ داغ',
      categoryId: 3, address: 'Somerset St, Ottawa', url: 'https://example.com/demo-business-2',
      hasDiscount: false, discountNote: null, isPromoted: true, status: 'published',
    },
    {
      id: 'biz-3', name: 'باشگاه بولینگ اتاوا 🎳', description: 'مناسب دورهمی گروهی',
      categoryId: 5, address: 'Merivale Rd, Ottawa', url: 'https://example.com/demo-business-3',
      hasDiscount: false, discountNote: null, isPromoted: false, status: 'published',
    },
  ];
}

export function demoAvailability(): AvailabilityCell[] {
  return [];
}

export const DEMO_NOTIF_PREFS: NotifPrefs = {
  friend_request: 'push', signal: 'push', event: 'inapp', tag_follow: 'push',
  indicator: 'dot', auto_update: true,
};
